// Projects are listed by name, description and technologies. Each one also gets
// its own page at /projects/<slug> (the slug comes from the name).
//
// Optional fields, each shown only when set:
//   code        GitHub link
//   slug        pin the URL (set this if you ever rename a project, so old links keep working)
//   role        what you did, e.g. 'Backend and architecture'
//   period      e.g. '2024'
//   problem     the problem it solves
//   highlights  an array of specific things you built or decided
//   outcome     what changed because of it
// Only add things that are true and that you can discuss in an interview.
//
// Order matters: the home page shows the first few, /projects shows all.
// When you add a project, also add its URL to public/sitemap.xml (a test tells you which).
export const projectsData = [
    {
        id: 0,
        projectName: 'Identity & Access Security Architecture',
        projectDesc: 'The user management and security layer of a microservices platform. Services verify RS256 tokens from trusted issuers on every request, scoped by audience and key id, with role-based, field-level and administration-unit permissions. Includes email verification, OTP flows, token blacklisting and an audit log.',
        tags: ['Django REST Framework', 'RS256 JWT', 'RBAC', 'Microservices'],
    },
    {
        id: 1,
        projectName: 'Master Service for Microservices',
        projectDesc: 'A master service that coordinates and provides unified access to multiple microservices, including User Management and Human Resource Management, backed by a Redis pub/sub service hub.',
        tags: ['Microservices', 'Redis pub/sub', 'React Bootstrap'],
    },
    {
        id: 2,
        projectName: 'Civil Case Management System',
        projectDesc: 'A system for registering and tracking civil cases and storing legal documents, with an integrated RAG chatbot (OpenAI API + LangChain) for natural-language search over case records.',
        tags: ['RAG', 'LangChain', 'OpenAI API', 'React Bootstrap'],
    },
    {
        id: 3,
        projectName: 'ZKTeco Device Integration for DrongoERP',
        projectDesc: 'A Node.js service that ingests, processes and synchronizes ZKTeco biometric device data with the ERP backend, packaged as an unattended Windows service, plus thermal-printer support over Web Bluetooth and serial port.',
        tags: ['Node.js', 'NSSM', 'Web Bluetooth API'],
    },
    {
        id: 4,
        projectName: 'Emergency Ambulance Booking',
        projectDesc: 'An emergency ambulance booking platform that lets users request medical assistance quickly, with real-time location tracking and dispatching.',
        tags: ['Real-time tracking', 'Dispatching'],
    },
    {
        id: 5,
        projectName: 'SMS Gateway',
        projectDesc: 'An SMS gateway that allows sending, receiving and managing text messages programmatically between users for notifications and communication.',
        tags: ['SAAS', 'Bootstrap', 'HTML', 'CSS'],
    },
    {
        id: 6,
        projectName: 'Poultry Disease Detection',
        projectDesc: 'An end-to-end computer vision project: dataset curation and annotation, model training, evaluation on held-out data, and iteration on misclassified cases.',
        tags: ['Computer Vision', 'Machine Learning'],
    },
    {
        id: 7,
        projectName: 'Online Bus Ticket Booking System',
        projectDesc: 'A web platform that allows users to search, book and manage bus tickets online with real-time availability and secure payments.',
        tags: ['SAAS', 'React Bootstrap'],
    },
    {
        id: 8,
        projectName: 'Photo Studio',
        projectDesc: 'A platform to manage photo studio operations, including booking sessions, storing photos and organizing client galleries.',
        tags: ['Bootstrap', 'Express', 'JavaScript'],
    },
]
